// extracted by mini-css-extract-plugin
export default {"footer":"footer_footer__OtPJ0","footerItem":"footer_footerItem__LA2l1"};